import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import MemoriesEditor from 'src/common/components/memories/MemoriesEditor';

export default function SavedMemories() {
  const { clientId } = useCurrentClient();

  return (
    <MemoriesEditor
      title="Saved memories"
      description="These memories are shared across all advisors and are used by the AI to personalise conversations, documents, and meeting notes for this client."
      emptyText="No memories saved yet. Memories are created automatically during conversations with the AI."
      queryKey={['memories', 'clients', clientId]}
      apiEndpoint={`/memories/clients/${clientId}`}
    />
  );
}
